import ShiftsGetter from "components/Dashboard/range-selectors/ShiftsGetter";
import { useSelector } from "store/useSelector";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";

export function ShiftsGetterConnected() {
  const ckey = useCustomerKey();
  const { isHubletPage, isOperatorPage, isTrendsPage, isGridLayoutPage } =
    useGetPageFromPath();
  const isTrendsPageFinishedInitialFilter = useSelector(
    state => state.legacy.isTrendsPageFinishedInitialFilter
  );

  // on Trends page, wait for the initial filter to complete before fetching shifts
  const shouldFetch =
    ckey && (!isTrendsPage || isTrendsPageFinishedInitialFilter);
  return shouldFetch ? (
    <ShiftsGetter
      shouldGoToCurrentShiftOnFetch={
        !isHubletPage && !isOperatorPage && !isTrendsPage && !isGridLayoutPage
      }
    />
  ) : null;
}
